import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import Button from 'components/button';

import icClose from 'assets/svgs/ac-close.svg';

const StyledButton = styled(Button)`
  margin-top: 32px;
  margin-right: 16px;
`;

const CTAs = ({
  isProcessingComplete, handleOnClickCancel, clean, uploadProgress,
}) => {
  const { t } = useTranslation();

  if (isProcessingComplete) {
    return (
      <>
        <StyledButton
          onClick={() => {}}
          disabled
        >
          {t('pages.importerPage.publishButton')}
        </StyledButton>
        <StyledButton
          variant="secondary"
          onClick={clean}
        >
          {t('pages.importerPage.newImportButton')}
        </StyledButton>
      </>
    );
  }
  return (
    <StyledButton
      variant="link"
      onClick={handleOnClickCancel}
      disabled={uploadProgress !== 100}
      icon={icClose}
    >
      {t('pages.importerPage.cancelButton')}
    </StyledButton>
  );
};

CTAs.propTypes = {
  handleOnClickCancel: PropTypes.func.isRequired,
  clean: PropTypes.func.isRequired,
  isProcessingComplete: PropTypes.bool.isRequired,
  uploadProgress: PropTypes.number.isRequired,
};

export default CTAs;
